// extracted by mini-css-extract-plugin
export default {"container":"uhUFbh7FENY8ximMrMB3","shift-from-left":"TFPUApn2xNo9_iFmEyWI","shift-right":"h80f0Wf9cuDWcpMCXgZX","tabContainer":"FonTEuKmtml8vv5PmZw_","pill":"iQjSDZte63JWV1PGvWaD"};